import { React, useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import api from "../../Utils/api";
import AgGridComponent from "../../Components/Common/AgGridComponent";
import * as XLSX from "xlsx";
import UserSetting from "../../UserSettings.json";
import {
  getCurrentDateTime,
  formatDate
  
} from "../../Utils/commonfunctions";
//import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./GetDailyGrowingReport.css";
const GetDailyGrowingReport = () => {
  const [startDate, setStartDate] = useState("");
  //const [endDate, setEndDate] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [groupSummeryData, setSummeryData] = useState([]);
  const [groupDetailData, setDetailData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const StartDateRef = useRef(null);
  

const [summary, setSummary] = useState([]);
const [details, setDetails] = useState([]);
  useEffect(() => {
    if (StartDateRef.current) {
      StartDateRef.current.focus();
    }
  }, []);


  useEffect(() => {
     setStartDate(getCurrentDateTime);
     //setEndDate(getCurrentDateTime);
     setSummeryData([]);
     setDetailData([]);
     
   }, []);
  const ClearData = () => {
    setShowTable(false);
    //setEndDate(getCurrentDateTime);
    setStartDate(getCurrentDateTime);
    
    
  };
   
  const PrintMachineProductionReport = () => {
    debugger;
    setIsLoading(true); // Show loader

    if (startDate === "" || startDate === null) {
      return Swal.fire("Error", "Please Select Start Date", "error");
    }

    // if (endDate === "" || endDate === null) {
    //   return Swal.fire("Error", "Please Select End Date", "error");
    // }
 

    setShowTable(false);
    setSummeryData([]);
     setDetailData([]);
    const formattedStartDate = formatDate(startDate);
    ///const formattedEndDate = formatDate(endDate);

    api
    .get(
        `Report/PrintGetDailyGrowingReport?START_DATE=${formattedStartDate}`
    )
    // 
   .then((result) => {

    const apiData = result.data?.data || {};

    const summary = apiData.summary || [];
    const details = apiData.detail || [];

    console.log("API DATA:", apiData);
    console.log("SUMMARY:", summary);
    console.log("DETAILS:", details);
    console.log("DETAIL COUNT:", details.length);


    const sortOrder = {
        "6KW DETAIL": 1,
        "6KW TOTAL": 2,
        "12KW DETAIL": 3,
        "12KW TOTAL": 4,
        "GRAND TOTAL": 5
    };


    const sortedSummary = [...summary].sort((a, b) => {

        const orderA = sortOrder[a.rowType] || 99;
        const orderB = sortOrder[b.rowType] || 99;

        if (orderA !== orderB) {
            return orderA - orderB;
        }


        if (
            a.rowType === "6KW DETAIL" ||
            a.rowType === "12KW DETAIL"
        ) {

            if ((a.kw || 0) !== (b.kw || 0)) {
                return (a.kw || 0) - (b.kw || 0);
            }


            if ((a.machineID || 0) !== (b.machineID || 0)) {
                return (a.machineID || 0) - (b.machineID || 0);
            }


            return String(a.batchNo || "")
                .localeCompare(
                    String(b.batchNo || "")
                );
        }

        return 0;
    });


    // ==========================================
    // SAVE SUMMARY
    // ==========================================

    setSummary(sortedSummary);
    setSummeryData(sortedSummary);


    // ==========================================
    // SAVE ALL DETAILS
    // ==========================================

    setDetails(details);
    setDetailData(details);


    // ==========================================
    // SHOW REPORT
    // ==========================================

    setShowTable(
        sortedSummary.length > 0 ||
        details.length > 0
    );

})
    .catch((error) => {
        console.log(error);

        setSummeryData([]);
        setDetailData([]);
        setShowTable(false);

        Swal.fire(
            "Error",
            "Unable to get Daily Growing Report",
            "error"
        );
    })
    .finally(() => {
        setIsLoading(false);
    });
  };


  const columnDefs = [
    {
      headerName: "SrNo",
      field: "srNo",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
     {
      headerName: "Machine Start Date",
      field: "machineStartDate",
      flex: 1,
      minWidth: 100,
      cellStyle: { textAlign: "left" },
      valueFormatter: (params) => {
        if (params.value) {
          const date = new Date(params.value);
          const formattedDate = date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
          return formattedDate;
        }
        return "";
      },
    },
    {
      headerName: "Machine End Date",
      field: "machineEndDate",
      flex: 1,
      minWidth: 100,
      cellStyle: { textAlign: "left" },
      valueFormatter: (params) => {
        if (params.value) {
          const date = new Date(params.value);
          const formattedDate = date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
          return formattedDate;
        }
        return "";
      },
    },
     
    {
      headerName: "Machine No",
      field: "machineNo",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    
    {
      headerName: "Machine Hours",
      field: "machineHours",
      wrapHeaderText: true,
      width: "150px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    
    },
    {
      headerName: "BatchNo",
      field: "batchNo",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "Pcs",
      field: "pcs",
      width: "130px",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Broken",
      field: "broken",
      width: "130px",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    },
    
    {
      headerName: "Seed Height",
      field: "seedHeight",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "Grow Height",
      field: "growHeight",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "Growth(Height)",
      field: "growthHeight",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "Height Per Hour",
      field: "heightPerHour",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    
    {
      headerName: "Seed Weight",
      field: "seedWeight",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "GrowWeight",
      field: "growWeight",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "Growth (Weight)",
      field: "growthWeight",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    
    
    {
      headerName: "WeightPerHour",
      field: "weightPerHour",
      width: "180px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
     
    },
     {
      headerName: "Grow Rate",
      field: "growRate",
      wrapHeaderText: true,
      width: "150px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    
    },
    // {
    //   headerName: "Hrs-Efficiency %",
    //   field: "efficiency",
    //   wrapHeaderText: true,
    //   width: "170px",
    //   autoHeaderHeight: true,
    //   wrapText: false,
    //   autoHeight: false,
    //   sortable: true,
    //   filter: true,
    //   cellStyle: { textAlign: "left" },
      
    // },
    
   ];
  

  const exportToExcel = () => {
    if (groupSummeryData.length > 0) {
      const params = {
        fileName: "Machine_Production-Data.xlsx",
        sheetName: "Data",
      };

      const excelData = [];
      const columns = [];

      // Extract column headers
      columnDefs.forEach((column) => {
        columns.push(column.headerName);
      });

      excelData.push(columns);

      // Add data rows
      groupSummeryData.forEach((row) => {
        const rowData = [];
        columnDefs.forEach((column) => {
          rowData.push(row[column.field]);
        });
        excelData.push(rowData);
      });

      const totalRow = [ ];
      excelData.push(totalRow);

      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, params.sheetName);

      XLSX.writeFile(wb, params.fileName);
    }
  };
 const formatReportDate = (value) => {

    if (!value) {
        return "";
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });
};
  const exportToExcelDetail = () => {
    if (groupSummeryData.length > 0) {
      const params = {
        fileName: "DetailMachine_Report-Data.xlsx",
        sheetName: "Data",
      };

      const excelData = [];
      const columns = [];

      // Extract column headers
      columnDefs.forEach((column) => {
        columns.push(column.headerName);
      });

      excelData.push(columns);

      // Add data rows
      groupDetailData.forEach((row) => {
        const rowData = [];
        columnDefs.forEach((column) => {
          rowData.push(row[column.field]);
        });
        excelData.push(rowData);
      });

      // Add total row
       const totalRow = [
      
       ];
      excelData.push(totalRow);

      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, params.sheetName);

      XLSX.writeFile(wb, params.fileName);
    }
  };

  
 debugger
   return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <span>DAILY GROWING REPORT</span>
        </div>
        <div className="card-body">
          <div className="row col-md-12 mb-3">
            <div className="col-md-2 col-sm-2 col-lg-2">
              <strong htmlFor="startDate">Start Date:</strong>
              <input
                ref={StartDateRef}
                type="datetime-local"
                className="form-control"
                id="startDate"
                placeholder="Enter Machine Start Time"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            {/* <div className="col-md-2 col-sm-2 col-lg-2">
              <strong htmlFor="endDate">End Date:</strong>
              <input
                type="datetime-local"
                className="form-control"
                id="endDate"
                placeholder="Enter Machine Start Time"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div> */}
            
            <div className="col-md-2 col-sm-2 col-lg-2">
              <br />
              <button
                type="submit"
                className="btn btn-primary"
                onClick={PrintMachineProductionReport}
              >
                <i class="fa fa-search"></i>
                {"  "}
                Search
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={ClearData}
                style={{ marginLeft: "10px" }}
              >
                <i class="fa fa-refresh"></i>
                {"  "}
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        {isLoading && (
          <>
            <div className="overlay"></div>
            <div className="overlay-content text-center">
              <Spinner animation="" variant="primary">
                <span class="loader"></span>
              </Spinner>
            </div>
          </>
        )}

        <div className="card-header">
          <span>Daily Growing Report</span>
        </div>
        <div className="card-body">
          {showTable ? (
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button className="btn btn-primary mb-2" onClick={exportToExcel}>
                <i class="fa fa-file-excel"></i> Export to Excel
              </button>


              {details.length > 0 && (
                  <button
                      className="btn btn-success mb-2"
                      onClick={() => window.print()}
                      style={{ marginLeft: "10px" }}
                  >
                      <i className="fa fa-print"></i>{" "}
                      Print Report
                  </button>
              )}
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <strong>Data Not Found</strong>
            </div>
          )}
          {showTable && (
            <>
              <AgGridComponent 
                    columnDefs={columnDefs}
                    rowData={groupSummeryData}
                    paginationPageSize={100}
                    height="80vh"
                />
            </>
          )}
        </div>
      </div>

        

       <div className="card">

    {isLoading && (
        <>
            <div className="overlay"></div>

            <div className="overlay-content text-center">

                <Spinner animation="" variant="primary">
                    <span className="loader"></span>
                </Spinner>

            </div>
        </>
    )}


    <div className="card-header">
        <span>Daily Growing Reports</span>
    </div>


    <div className="card-body">

        {details.length === 0 ? (

            <div
                style={{
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <strong>
                    Data Not Found
                </strong>
            </div>

        ) : (

            <>

                {details.map((item, index) => (

                    <div
                        className="report-page"
                        key={`${item.machineID}-${item.batchNo}-${index}`}
                    >

                        <div className="daily-report">


                            {/* =====================================
                                COMPANY HEADER
                            ===================================== */}

                            <div className="company-header">

                                {item?.companyName ||
                                    item.companyName ||
                                    "SPLENDID DIAMOND TECH PVT. LTD."}

                            </div>


                            {/* =====================================
                                REPORT TITLE
                            ===================================== */}

                            <div className="report-title">

                                DAILY GROWING REPORT -{" "}

                                {item.reportDate ||
                                    startDate}

                            </div>


                            {/* =====================================
                                MACHINE
                            ===================================== */}

                            <div className="machine-title">

                                MACHINE NO:{" "}

                                {item.machineNo}

                                {" "}

                                ({item.kw} KW)

                            </div>


                            {/* =====================================
                                LOT
                            ===================================== */}

                            <div className="lot-title">

                                LOT-{item.batchNo}

                            </div>


                            {/* =====================================
                                MACHINE SUMMARY
                            ===================================== */}

                            <table className="summary-table">

                                <thead>

                                    <tr>

                                        <th colSpan="2">
                                            MACHINE START DATE
                                        </th>

                                        <th colSpan="2">
                                            MACHINE END DATE
                                        </th>

                                        <th>
                                            DAYS
                                        </th>

                                        <th>
                                            PCS
                                        </th>

                                        <th className="broken-header">
                                            BROKEN
                                        </th>

                                        <th>
                                            TOTAL HRS
                                        </th>

                                        <th>
                                            GROW
                                            <br />
                                            RATE
                                        </th>

                                    </tr>

                                </thead>


                                <tbody>

                                    <tr>

                                        {/* START DATE */}

                                        <td colSpan="2">

                                            {formatReportDate(
                                                item.machineStartDate
                                            )}

                                        </td>


                                        {/* END DATE */}

                                        <td colSpan="2">

                                            {formatReportDate(
                                                item.machineEndDate
                                            )}

                                        </td>


                                        {/* DAYS */}

                                        <td>

                                            {item.days ?? ""}

                                        </td>


                                        {/* PCS */}

                                        <td>

                                            {item.pcs ?? ""}

                                        </td>


                                        {/* BROKEN */}

                                        <td className="broken-value">

                                            {item.broken ?? ""}

                                        </td>


                                        {/* HOURS */}

                                        <td>

                                            {item.machineHours ?? ""}

                                        </td>


                                        {/* GROW RATE */}

                                        <td>

                                            {item.growRate ?? ""}

                                        </td>

                                    </tr>

                                </tbody>

                            </table>


                            {/* =====================================
                                HEIGHT / WEIGHT
                            ===================================== */}

                            <table className="measurement-table">

                                <tbody>

                                    <tr>

                                        <th>
                                            HEIGHT (BEFORE) :-
                                        </th>

                                        <td>
                                            {item.heightBefore ?? ""}
                                        </td>

                                        <th>
                                            WEIGHT (BEFORE) :-
                                        </th>

                                        <td>
                                            {item.weightBefore ?? ""}
                                        </td>

                                    </tr>


                                    <tr>

                                        <th>
                                            HEIGHT (AFTER) :-
                                        </th>

                                        <td>
                                            {item.heightAfter ?? ""}
                                        </td>

                                        <th>
                                            WEIGHT (AFTER) :-
                                        </th>

                                        <td>
                                            {item.weightAfter ?? ""}
                                        </td>

                                    </tr>


                                    <tr>

                                        <th className="blue-text">

                                            GROWTH (HEIGHT) :-

                                        </th>

                                        <td className="blue-text">

                                            {item.growthHeight ?? ""}

                                        </td>


                                        <th className="green-text">

                                            GROWTH (WEIGHT) :-

                                        </th>

                                        <td className="green-text">

                                            {item.growthWeight ?? ""}

                                        </td>

                                    </tr>


                                    <tr>

                                        <th className="blue-text">

                                            HEIGHT PER HOUR :-

                                        </th>

                                        <td className="blue-text">

                                            {item.heightPerHour ?? ""}

                                        </td>


                                        <th className="green-text">

                                            WEIGHT PER HOUR :-

                                        </th>

                                        <td className="green-text">

                                            {item.weightPerHour ?? ""}

                                        </td>

                                    </tr>

                                </tbody>

                            </table>


                            {/* =====================================
                                IMAGES
                            ===================================== */}

                            <table className="image-table">

                                <thead>

                                    <tr>

                                        <th>
                                            BEFORE GROWING IMAGE
                                        </th>

                                        <th>
                                            AFTER GROWING IMAGE
                                        </th>

                                    </tr>

                                </thead>


                                <tbody>

                                    <tr>

                                        <td>

                                            <div className="image-container">

                                                {item.beforeImage ? (

                                                    <img
                                                        src={UserSetting.imgURL + item.beforeImage}
                                                        alt="Before Growing"
                                                    />

                                                ) : (

                                                    <div className="no-image">

                                                        No Image

                                                    </div>

                                                )}

                                            </div>

                                        </td>


                                        <td>

                                            <div className="image-container">

                                                {item.afterImage ? (

                                                    <img
                                                        src={UserSetting.imgURL + item.afterImage}
                                                        alt="After Growing"
                                                    />

                                                ) : (

                                                    <div className="no-image">

                                                        No Image

                                                    </div>

                                                )}

                                            </div>

                                        </td>

                                    </tr>

                                </tbody>

                            </table>


                            {/* =====================================
                                FOOTER
                            ===================================== */}

                            <div className="report-footer">

                                Page {index + 1} of {details.length}

                            </div>


                        </div>

                    </div>

                ))}

            </>

        )}

    </div>

</div>

   
    </>
  );
};

export default GetDailyGrowingReport;